<template>
<div class="page-container">
    <h2>HBR Labs</h2>
    <p>Please upload pitch decks below</p>
    <!--progress style="transition: 200ms" :value="uploadProgress" max="100" id="uploader" v-bind:class="[ uploadDone ? 'uploadDone' : '' ]">0%</progress-->
    <input @change="stageUpload" type="file" value="upload" :class="( fileTarget ? 'hydrated' : '' )" class="fileField" id="fileButton" />
    <button @click="handleUpload()" id="upload-btn" :class="( fileTarget ? ( loaderState ? 'load' : 'upload' ) : 'upload-inactive' )">{{ btnContext }}</button>
    <a class="return-btn" v-if="complete" href="https://home.hbrconsulting.com/SitePages/Innovation.aspx">Return to SharePoint</a>
</div>
</template>

<script>
import firebase from 'firebase';

export default {
    name: 'InnovationUpload',
    data() {
        return {
            fileTarget: null,
            loaderState: false,
            btnContext: 'Upload Deck',
            complete: false
        }
    },
    mounted() {
        console.log('upload page mounted');
    },
    methods: {
        stageUpload(e) {
            this.fileTarget = e.target;
            console.log('STAGING FILE: ', this.fileTarget);
        },
        handleUpload() {
            var self = this;
            var task = [];

            this.loaderState = true;
            this.btnContext = '';

            console.log('loader state?: ', this.loaderState);
            console.log('button context?: ', this.btnContext);

            for(let i = 0; i < this.fileTarget.files.length; i++) {
                //push file into storage
                task.push(firebase.storage().ref("Innovation_Decks/" + this.fileTarget.files[i].name).put(this.fileTarget.files[i]));
            
                //update progress bar and handle onComplete
                task[i].on('state_changed', function progress(snapshot) {
                    console.log('uploading...', snapshot);
                },
                    function error(err) {
                        console.log('oopsie woopsie', err);
                    },
                    function complete() {
                        //console.log(storageRef.child(imgPath).getDownloadURL().getResults());

                        task[i].snapshot.ref.getDownloadURL().then(
                            function(downloadURL) {
                                self.loaderState = false;
                                console.log('File available at: ' + downloadURL);
                                document.getElementById('upload-btn').style.background = "rgba(0,255,0,0.1)";
                                document.getElementById('upload-btn').style.color = "green";
                                document.getElementById('upload-btn').style.pointerEvents = "none";
                                document.getElementById('upload-btn').style.cursor = "default";
                                self.btnContext = "Upload complete! Thank you for submitting";
                                self.complete = true;
                            }
                        )
                    }
                )
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.page-container {
    flex-direction: column;
}

.fileField {
    background: #f6f6f6;
    padding: 120px 240px 120px 318px;
    border-radius: 24px;
    border: dashed #e0e0e0 2px;
    transition: 300ms;
    cursor: pointer;
    outline: none;

    &:hover {
        border: solid 2px #e0e0e0;
        background: #eee;
        transform: scale(0.98);
    }
}

h2 {
    font-size: 32px;
}

p {
    margin-bottom: 48px;
    font-weight: normal;
}

.upload {
    background: #386C81;
    color: white;
    border-radius: 24px;
    padding: 12px 24px;
    margin-top: 32px;
    transition: 300ms;
    cursor: pointer;
    user-select: none;
    outline: none;

    &:hover {
        transform: scale(1.1);
    }
}

.upload-inactive {
    background: #386C81;
    color: white;
    filter: grayscale(1);
    cursor: not-allowed;
    border-radius: 24px;
    padding: 12px 24px;
    margin-top: 32px;
    transition: 300ms;
    pointer-events: none;
    opacity: 0.3;
    outline: none;
}

.load {
    background: transparent;
    border: dashed 6px orange; 
    border-radius: 24px;
    padding: 12px 12px;
    margin-top: 32px;
    transition: 300ms;
    pointer-events: none; 
    animation: spin 2s linear forwards infinite;
    outline: none;
}

.hydrated {
    border: black solid 2px;
}

.return-btn {
    background: black;
    color: white;
    border-radius: 24px;
    padding: 12px 24px;
    margin-top: 24px;
    font-size: 14px;
    transition: 300ms;
    cursor: pointer;

    &:hover {
        transform: scale(1.05);
    }
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    } to {
        transform: rotate(360deg);
    }
}
</style>